import type { Category } from "@/entities/categories/model/types/categories";
import { useCategoriesStore } from "@/entities/categories/store";

export const useCategories = () => {
  const categoriesStore = useCategoriesStore();
  const route = useRoute();
  const { t, locale } = useI18n();
  const localePath = useLocalePath();

  const category = computed(() => {
    return categoriesStore.parentCategories.find(
      category =>
        category.slug_ru === route.params.category ||
        category.slug_en === route.params.category ||
        category.slug_uz === route.params.category,
    ) || null;
  });

  const subcategories = computed(() => {
    if (!category.value) {
      return [];
    }

    const categorySlug = category.value[`slug_${locale.value}`];

    const allProductsCategory = {
      id: category.value.id,
      name: t('allProductsCategory'),
      [`slug_${locale.value}`]: category.value[`slug_${locale.value}`],
      icon: category.value.icon,
      parent: category.value.parent,
      link: localePath({
        name: 'catalog-category',
        params: { category: categorySlug },
      }),
    };

    return [
      allProductsCategory,
      ...categoriesStore.categories
        .filter((cat: Category) => cat.parent === category.value?.id)
        .map((cat: Category) => {
          const subcategorySlug = cat[`slug_${locale.value}`];
          return {
            ...cat,
            link: localePath({
              name: 'catalog-category-subcategory',
              params: { category: categorySlug, subcategory: subcategorySlug },
            }),
          };
        })
    ];
  });

  const selectedItem = computed(() => {
    const subcategory = route.params.subcategory || '';
    return subcategory
      ? categoriesStore.categories.find((cat: Category) =>
          cat.slug_ru === subcategory ||
          cat.slug_en === subcategory ||
          cat.slug_uz === subcategory
        )
      : category.value
        ? category.value
        : {
          id: 0,
          name: '',
          slug_ru: '',
          slug_en: '',
          slug_uz: '',
          icon: '',
          parent: 0,
          link: ''
        }
  });

  return {
    selectedItem,
    category,
    subcategories,
  };
};
